export default __webpack_public_path__ + "static/media/addResourceWhite.de34be5b.svg";